import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import TeamSummaryMatchupDataContainer from '@gameday/components/TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import Panel from '@gameday/components/Panel/Panel';
import { PanelScreenWrapper, ScoresCardWrapper, MatchUpCardWrapper, LiveBoxscoreWrapper } from '../Live.style';
import { liveViewsTypes } from '../../themes/liveViewsTypes';
import BoxscoreDataContainer from '@gameday/components/Boxscore/BoxscoreDataContainer';
import { BoxScoreViewTypes } from '@gameday/components/Boxscore/Boxscore.style';
import LineScoreDataContainer from '../../LineScore/containers/LineScoreDataContainer';
import { LiveTeamSummaryProps } from '../Live';
import MatchupDataContainer from '../../Matchup/containers/MatchupDataContainer';
const trackingConfig = ['Live', 'TeamSummaryMatchup'];

const { FULL, FULLNARROW, FULLWIDE } = liveViewsTypes;
const PanelWideScreen = ({
    handleRightPanelToggle,
    viewType = FULL,
    tabs
}) => {
    return (
        <PanelScreenWrapper>
            <Panel
                controlOpen={ true }
                hideButton={ true }
                trackingId='desktop-left'
            >
                {tabs}
            </Panel>
            {(viewType === FULLNARROW || viewType === FULL || viewType === FULLWIDE) &&
                <>
                    <ScoresCardWrapper type={viewType}>
                        <TeamSummaryMatchupDataContainer {...LiveTeamSummaryProps} useTri={true} componentName={trackingConfig} />
                    </ScoresCardWrapper>
                    <MatchUpCardWrapper type={viewType}>
                        <MatchupDataContainer />
                    </MatchUpCardWrapper>
                </>
            }
            <Panel
                controlOpen={true}
                side={'right'}
                hideButton={true}
                toggleHandler={handleRightPanelToggle}
                trackingId='desktop-right'
            >
                <LineScoreDataContainer useFullName={viewType === FULLWIDE} />
                <LiveBoxscoreWrapper $type={viewType}>
                    <BoxscoreDataContainer viewType={viewType === FULLWIDE ? BoxScoreViewTypes.WIDE : BoxScoreViewTypes.NARROW} showBench={true} showBullpen={true} />
                </LiveBoxscoreWrapper>
            </Panel>
        </PanelScreenWrapper>
    );
};

PanelWideScreen.propTypes = {
    tabs: PropTypes.object,
    handleRightPanelToggle: PropTypes.func,
    viewType: PropTypes.string
};

export default withTheme(PanelWideScreen);
